import { render, staticRenderFns } from "./FieldDisplay.vue?vue&type=template&id=aa28b4f2&"
import script from "./FieldDisplay.vue?vue&type=script&lang=js&"
export * from "./FieldDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FieldDisplay.vue?vue&type=style&index=0&id=aa28b4f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports